import o from"styled-components";import{theme as t}from"../../../theme.js";const e=o.div`
  display: flex;
`,r=o.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
  > svg {
    width: 40px;
    height: 40px;
    > g, path {
      fill: ${({active:i})=>i?t.colors.additional.orange[300]:t.colors.gray[300]};
    }
  }
  /* &:hover {
    > svg {
      > g, path {
        fill: ${t.colors.additional.orange[300]}
      }
    }
  } */
`;export{e as Container,r as StarButton};
